import { FC } from "react"
import { usePatentStore } from "../../../hooks/usePatentStore"
import { Box, Divider, Drawer, FormLabel, Grid, IconButton, TextField, Typography } from "@mui/material"
import { Formik } from "formik"
import CloseIcon from '@mui/icons-material/Close'
import { ModalFooter } from "../../../components/common/Modal/ModalFooter"
import { ApiStatus } from "../../../types/api/status"

interface PatentFormDrawerProps {
    open: boolean
    onClose: () => void
    onList: () => void
}

type ValuesForm = {
    name: string
}


export const PatentFormDrawer: FC<PatentFormDrawerProps> = ({
    open,
    onClose,
    onList
}) => {
    const { status, patentSelected, createPatent, updatePatent } = usePatentStore()

    const isEdit = patentSelected && Object.keys(patentSelected).length > 0
    const data: ValuesForm = {
        name: patentSelected?.name || ''
    }

    const validateForm = (values) => {
        let errors: any = {};

        if (!values.name) errors.name = "el campo es requerido";

        return errors;
    }

    const onSubmit = async (values: ValuesForm): Promise<void> => {
        const payload = {
            name: values.name
        }
        
        const resp = await (!isEdit ? createPatent(payload) : updatePatent(patentSelected?.id, payload))
        if (resp == true) {
            onClose()
            onList()
        }
    }

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: { xs: '100%', sm: 480 },
                    borderRadius: '12px 0 0 12px',
                    backgroundColor: '#fafafa',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                px={2}
                py={1.5}
                sx={{
                    backgroundColor: '#f5f7f9',
                    borderBottom: '1px solid #e0e0e0'
                }}
            >
                <Box>
                    <Typography variant="h6" fontWeight={700}>
                        {`${isEdit ? 'Nueva' : 'Editar'} patente`}
                    </Typography>
                </Box>

                <IconButton
                    onClick={onClose}
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0.04)',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0.08)' },
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

            <Formik
                initialValues={data}
                enableReinitialize
                validate={validateForm}
                onSubmit={onSubmit}
            >
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} p={2}>

                                <Grid item xs={12}>
                                    <FormLabel>{'Patente:'}</FormLabel>
                                    <TextField
                                        id="name"
                                        type="text"
                                        name="name"
                                        fullWidth
                                        size="small"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={errors.name && touched.name ? true : false}
                                        helperText={errors.name && touched.name ? errors.name : ''}
                                    />
                                </Grid>

                                <Divider />

                                <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                    <ModalFooter
                                        buttonType="submit"
                                        confirmText={'Guardar'}
                                        onConfirm={handleSubmit}
                                        cancelText={"Cancelar"}
                                        onCancel={onClose}
                                        loadingConfirmText={status === ApiStatus.FETCHING}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    )
                }}
            </Formik>
        </Drawer>
    )
}